import { render, staticRenderFns } from "./RegistrationVsActive.vue?vue&type=template&id=1ab7b67e&scoped=true"
import script from "./RegistrationVsActive.vue?vue&type=script&lang=js"
export * from "./RegistrationVsActive.vue?vue&type=script&lang=js"
import style0 from "./RegistrationVsActive.vue?vue&type=style&index=0&id=1ab7b67e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab7b67e",
  null
  
)

export default component.exports